const app = {
  namespaced: true,
  state: {
    drawer: true,
    overlay: false,
    openModalPdf: false,
    urlPdf: null,
  },
  mutations: {
    TOGGLE_DRAWER(state) {
      state.drawer = !state.drawer;
    },
    TOGGLE_MODAL_PDF(state, data) {
      state.urlPdf = data;
      state.openModalPdf = !state.openModalPdf;
    },
    OVERLAY(state, data) {
      state.overlay = data;
    },
  },
  actions: {
    toggleDrawer(context) {
      context.commit('TOGGLE_DRAWER');
    },
    setOverlay(context, data) {
      context.commit('OVERLAY', data);
    },
    toggleModalPdf(context, data) {
      context.commit('TOGGLE_MODAL_PDF', data);
    },
  },
};

export default app;
